import { render, staticRenderFns } from "./ModUserDialog.vue?vue&type=template&id=565e8175&"
import script from "./ModUserDialog.vue?vue&type=script&lang=js&"
export * from "./ModUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports